export var dataHooks = {
  text: 'heading-text'
};
export var APPEARANCES = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5'
};